import { computed } from 'vue';
import { Shortcut } from '@/types/shortcut';
import store from '@/store';

export default class CountrySelectionComponent {
	public additionShortcuts = computed((): Shortcut[] => {
		return store.getters.additionShortcuts();
	});
}
